import { PRODUCT_LOGO_SRC } from "@/lib/branding/product-logo";

/** Notebook chrome / explore nav — same mark as product logo. */
export const FEEDBACK_ICON_SRC = PRODUCT_LOGO_SRC;

export type FeedbackIconVariant = "sidebar" | "notebook" | "floating";

/** Rendered px — unchanged from prior feedback icon sizes. */
export const FEEDBACK_ICON_DISPLAY_SIZE: Record<FeedbackIconVariant, number> = {
  sidebar: 20,
  notebook: 15,
  floating: 38,
};

/** @deprecated Notebook top bar uses 32×32 chrome cell; glyph is 16px inside. */
export const NOTEBOOK_CHROME_FEEDBACK_SIZE = 32;
